import React, { Component, Fragment } from "react";
import { Menu, Icon, Checkbox, Button } from "semantic-ui-react";
import { connect } from "react-redux";
import { createNotification, NOTIFICATION_TYPE_SUCCESS } from "react-redux-notify";
import { bindActionCreators } from "redux";
import svg_icon_path from "../../static/media/SVGSpriteIcon.svg"

class ClientGridAction extends Component {
    constructor(props) {
        super(props);

    }



    handleBulkEditClick = () => {
        this.props.toggleBulkEditForm();
    };

    render() {

        return (
            <Fragment>
                <Menu text icon className="linear-gradient ml-2 mr-2">
                    <Menu.Item
                        name="Bulk Edit"
                        onClick={this.handleBulkEditClick.bind(this)}>
                        <svg className={`svg_icon xcm-icon-edit-bulk size-24 mr-4`}>
                            <title> Bulk Edit </title>
                            <use xlinkHref={`${svg_icon_path}#xcm-icon-edit-bulk`}> </use>
                        </svg>
            Bulk Edit
          </Menu.Item>

                </Menu>
            </Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    
    return {
        clients: state.allClients.clients,
        selectedClientsIds: state.allClients.selectedClients.selectedClientsIds,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            createNotification,
        },
        dispatch
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(ClientGridAction);


